"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyBuilderHeader = void 0;
var react_1 = __importDefault(require("react"));
var Text_1 = require("office-ui-fabric-react/lib/Text");
var SaveControls_1 = require("./SaveControls");
var ViewLayoutToggle_1 = require("./ViewLayoutToggle");
/**
 * StrategyBuilderHeader - Top-of-tab header with the unsaved-changes block,
 * the descriptive copy and the responsive layout toggle.
 */
exports.StrategyBuilderHeader = function (_a) {
    var saveControls = _a.saveControls, viewLayoutToggle = _a.viewLayoutToggle;
    return (react_1.default.createElement("div", { className: "ws-tab-header" },
        react_1.default.createElement("div", { className: "ws-header-row" },
            react_1.default.createElement("div", { className: "ws-header-left" },
                react_1.default.createElement(SaveControls_1.SaveControls, __assign({}, saveControls))),
            react_1.default.createElement("div", { className: "ws-header-right" },
                react_1.default.createElement(Text_1.Text, { variant: "medium", className: "ws-page-description" }, "Build your client strategy by defining strategic levels and their elements. Add levels to create the hierarchy, populate each level with elements, and connect them to visualize the complete strategy flow in the graph preview."),
                react_1.default.createElement(ViewLayoutToggle_1.ViewLayoutToggle, __assign({}, viewLayoutToggle))))));
};
